import { Outlet } from 'react-router';
import { AppTopBar } from './AppTopBar';
import { AppSideBar } from './AppSideBar';
import {
  AddNewMenuModal,
  CreateOwnerFormModal,
  CreateSupplierFormModal,
  CreateTenantFormModal,
  UserLogoutDialogModal,
} from '../templates';

const AppLayout = () => {
  return (
    <>
      <AddNewMenuModal />
      <CreateTenantFormModal />
      <CreateOwnerFormModal />
      <CreateSupplierFormModal />
      <UserLogoutDialogModal />
      <div className="grid grid-cols-[80px_1fr] grid-rows-[80px_1fr] [grid-template-areas:'sidebar_topbar'_'sidebar_content'] h-screen">
        <div className="[grid-area:sidebar] bg-white">
          <AppSideBar />
        </div>
        <div className="[grid-area:topbar] bg-primary2">
          <AppTopBar />
        </div>
        <div className="[grid-area:content] bg-background2 overflow-y-auto pb-12">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default AppLayout;
